// eslint-disable-next-line no-shadow
export enum StreakInfoType {
  Known = 'StreakKnown',
  Unknown = 'StreakUnknown',
}

export type StreakWeekItem = {
  date: string;
  status: 'frozen' | 'met' | 'unmet';
  weekday: 'Fri' | 'Mon' | 'Sat' | 'Sun' | 'Thu' | 'Tue' | 'Wed';
};

export type StreakInfo = {
  freezes_available: number;
  streak: {
    created_at?: string;
    days: number;
    last_incremented_at?: string;
  };
  streak_deadline: string;
  streak_goal_met: boolean;
  streak_week_view: StreakWeekItem[];
};

export type StreakInfoUnknownState = {
  type: StreakInfoType.Unknown;
};

export type StreakInfoKnownState = {
  current: StreakInfo;
  dailyXp: number;
  freezesAwardedInSession: number;
  next: StreakInfo | null;
  screenVisible: boolean;
  streakGoal: number;
  streakGoalMetInSession: boolean;
  type: StreakInfoType.Known;
};

export type StreakInfoState = StreakInfoKnownState | StreakInfoUnknownState;
